import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import * as lodash from 'lodash';
import { Observable } from 'rxjs';
import { map, switchMap } from "rxjs/operators";



@Injectable({
  providedIn: 'root'
})
export class AuthServerProvider {

  constructor(private http: HttpClient, private localStorage: LocalStorageService) {
  }

  login(credentials: App.Credentials): Observable<any> {
    let body = new HttpParams()
      .append('client_id', 'ManagementPortalapp');
    const headers = new HttpHeaders()
      .append('Content-Type', 'application/x-www-form-urlencoded')
      .append('Accept', 'application/json');

    lodash.forEach(credentials, (value, key): void => {
      body = body.append(key, encodeURIComponent(value!));
    });
    if (!body.get('grant_type')) {
      body = body.append('grant_type', 'password');
    }

    return this.http.post('oauth/token', body, {
      headers
    })
      .pipe(
        map((tokenData: App.TokenData) => {
          this.localStorage.store('token', {
            accessToken: tokenData.access_token,
            refreshToken: tokenData.refresh_token
          });
          return tokenData;
        }),
        switchMap((tokenData: App.TokenData) => {
          const authHeaders = new HttpHeaders()
            .append('Authorization', 'Bearer ' + tokenData.access_token);

          return this.http.post('api/login', null, {
            headers: authHeaders,
            withCredentials: true
          });
        }),
      );
  }

  logout(): Observable<void> {
    return this.http.post<void>('api/logout', null);
  }
}
